import {breakItUp, getColumnsFromGrid, getDataFromGrid} from '../../../utils';
import type {AttributeValues, GridEditor, Permissions} from '../../../types';
import equal from 'fast-deep-equal';

const getAllValues = async (
	gridEditor: GridEditor,
	permissions: Permissions,
	setProgress?: (progress: number) => void,
): Promise<AttributeValues> => {
	if (process.env.NODE_ENV === 'development') {
		console.time('get-values/all');
	}

	const {round} = Math;

	const data = getDataFromGrid(gridEditor);
	const columns = getColumnsFromGrid(gridEditor);

	const attrValues: AttributeValues = {};
	const size = data.length;
	const amount = size <= 10 ? 1 : 10;

	const valuesWritables: Record<string, boolean[]> = {};

	await breakItUp<AttributeValues>(
		{
			amount,
			size,
		},
		(index) => {
			setProgress && setProgress(round(((index + 1) / size) * 100));

			const rowData = data[index];
			const perms = permissions[rowData.assetId];

			columns.forEach(({name, properties}) => {
				const existing = attrValues[name];

				if (!valuesWritables[name]) valuesWritables[name] = [];
				valuesWritables[name].push(
					!properties.readOnly && (!perms || !perms.includes(name)),
				);

				if (
					//properties.readOnly ||
					attrValues[name]?.multipleValues // ||
					//(perms && perms.includes(name))
				)
					return;

				const value = properties.parseOutValue
					? properties.parseOutValue(rowData[name])
					: rowData[name];

				if (existing === void 0) {
					attrValues[name] = {value};
					return;
				}

				if (equal(value, existing.value)) return;

				attrValues[name] = {
					multipleValues: true,
					value: undefined,
				};
			});
		},
	);

	Object.entries(valuesWritables).forEach(([name, writable]) => {
		attrValues[name].readOnly = !writable.some((w) => w === true);
	});

	setProgress && setProgress(100);

	if (process.env.NODE_ENV === 'development') {
		console.timeEnd('get-values/all');
	}

	return attrValues;
};

export default getAllValues;
